import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IRankState } from '@shared/models';
import * as Response from '@shared/models/rank/rank.response.type';

import { getRankListQuery } from '../queries';

const state: IRankState = {
    totalCount: 0,
    fetchingList: false,
    globalList: [],
    schoolList: [],
    individualGlobalRank: null,
    individualSchoolRank: null,
    fetchingOwn: false,
    own: null,
};

const rankSlice = createSlice({
    name: 'platform-rank',
    initialState: state,
    reducers: {
        setGlobalList: (state, { payload }: PayloadAction<Response.IRankListResponse>) => {
            state.globalList = payload.data;
            state.individualGlobalRank = payload.individualData;
            state.totalCount = payload.totalCount;
        },
        setSchoolList: (state, { payload }: PayloadAction<Response.IRankListResponse>) => {
            state.schoolList = payload.data;
            state.individualSchoolRank = payload.individualData;
            state.totalCount = payload.totalCount;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRankListQuery.pending, (state) => {
            state.fetchingList = true;
        });
        builder.addCase(getRankListQuery.rejected, (state) => {
            state.fetchingList = false;
        });
        builder.addCase(getRankListQuery.fulfilled, (state) => {
            state.fetchingList = false;
        });
    },
});

export const { setGlobalList, setSchoolList } = rankSlice.actions;
export const rankRootReducer = rankSlice.reducer;
